<div class="overlay">
  <div class="top-right">
    <span class="schrift">Erfüllung</span>
  </div>
</div>
<canvas style="width: 100%" #canvas [id]="chartId">{{ chart }}</canvas>
